var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" problemes a la xarxa o problemes de conexio pulsa el boto enrera i torna-ho a provar "),_c('router-link',{attrs:{"to":{ name: 'Home'}}},[_vm._v("O torna a the Home Page")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }